"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
var _indexModule = _interopRequireDefault(require("./index.module.css"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _index = _interopRequireDefault(require("../../components/table/index"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StyleWrapper = _styledComponents.default.div`

ul{

    background-color: #054894;
    box-shadow: 1px 1px 8px #c7c7c7;
    border-radius: 10px;
    padding: 20px 20px;
    color: #fff;

}

p{
    // color:grey;
    margin-bottom:0.5rem;
}

h2{
    // color: #164686;
    margin-bottom:20px;
}

h4{
    // color: #164686;
    margin-bottom:20px;
}



`;
const TableWrapper = _styledComponents.default.div`

.table-bordered thead td, .table-bordered thead th {
min-width: 100px !important;
vertical-align: top !important;
}
th {
   background: #1e91ce;
   font-size: 15px;
   color: #fff;
   font-weight: 500;
   border: 1px solid white;
   border-top: 0px !important;
   padding: .60rem;
 }
  td {
      padding: .75rem;
    font-size: 13px;
    background: #ececec;
    vertical-align: middle;
 }
.table-responsive > .table-bordered {
  border: 0;
  font-size: 15px;
}
.table-responsive{
    overflow-x:none;
}
@media(max-width:768px){
    .table-bordered thead td, .table-bordered thead th {
      min-width: auto !important;
      vertical-align: top !important;
      }
      .table-bordered > thead > tr > th:first-child{
        width: auto !important;
      }
      .table-responsive{
          overflow-x: auto;
      }
  }
`;
const VaccationHomes = () => {
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.hero_image
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Vacation Home"))), /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: _indexModule.default.pageContainer
  }, /*#__PURE__*/_react.default.createElement(StyleWrapper, null, /*#__PURE__*/_react.default.createElement("p", null, "Ever thought about owning a vacation home? Get personal access to a beachfront retreat, lakeside bungalow, river lodge, mountain cabin, hillside ranch, country cottage, or a private ski chalet. Just imagine the possibilities! Use your vacation property as a place where you, your family, and your friends can gather for recreation. Have your vacation home near your family's favorite vacation destination, or have it near some place where you can enjoy the great outdoors so you can keep your family healthy with outdoor activities. You or your family may prefer a certain lifestyle, and a vacation home is a great place where they can enjoy or develop a unique lifestyle all within the confines of an exclusive environment."), /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: _indexModule.default.headerRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.header_border
  }, " "), /*#__PURE__*/_react.default.createElement("h4", null, "Some things about a vacation home that you may not have considered before:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Your family has the freedom to visit their favorite vacation spot at any time during the year without having to worry about hotel reservations and the need to have to check in and out of your hotel room on time. You can have your vacation home near your family's favorite vacation spot while keeping it in a private setting away from the crowds when your family need to rest."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, "You may also consider buying or building your vacation home in a natural setting and enjoy a change-of-pace away from the city life so your family can have a piece of nature to themselves."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, "A vacation home offers convenience to you and your family. With a vacation home, you can furnish the place with all of your family's favorite amenities and be able to store many of your family's personal belongings and worry less about packing and carrying your luggage. Your vacation home is your \"home away from home.\""), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, "Lend your vacation home to extended family members and your closest friends. In fact, why not share the costs and invest in a vacation home together with family members or close friends?"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, "Are you an individual who is required to travel between two cities because of your work? If that is the case, then a vacation home can also be used as your second home or an investment property."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, "You can also use your vacation home as an investment property if it is not used for most of the year, so you can generate more income. This is especially beneficial if your favorite vacation spot has a steady increase of visitors from year to year, where real-estate values continue to climb.")), /*#__PURE__*/_react.default.createElement("p", null, "Owning a vacation home has other appeals as well, such as additional tax benefits. However, before considering a vacation home, make sure to evaluate variables such as whether a vacation home fits reasonably within your budget. Also, get to know the area well and learn how you will manage your vacation home when you are away from it.")), /*#__PURE__*/_react.default.createElement("p", null, " A vacation home is no longer something you can only dream about. With our full line of financing options, Sun West can make this dream a reality for you and your family!"))));
};
var _default = exports.default = VaccationHomes;